import { BANK_ACCOUNT_NUMBER_REGEX_PATTERN } from "common/constants/regex";
import { isValidCommaSeperatedEmail } from "helpers/validators";
import { ElectricityAgreementForm } from "models/electricity/new-electricity-agreement";
import React from "react";
import { Form } from "react-bootstrap";

export default function NewElectricityAgreementBillingForm(
  {  form, setForm }:
  {  form: ElectricityAgreementForm, setForm: any }
) {
  return (
        <div>
          <p>Saadame arve e-posti aadressile: {form.electricityInvoiceRecipientEmailEnabled && !!form.electricityInvoiceRecipientEmail?.length ? form.electricityInvoiceRecipientEmail : form.email}</p>
          <div className="row mt-3">
              <div className="col-12 col-md-6">
                    <Form.Check
                        id='check-e-invoice'
                        custom
                        type="checkbox"
                        className='checkbox-large'
                        label='Soovin ka e-arvet panka'
                        onChange={() => setForm({...form, eInvoice: !form.eInvoice})}
                        checked={form.eInvoice}
                    />
                </div>
            </div>
            {form.eInvoice && (
              <Form className="row mt-1" noValidate validated={form.validated}>
                <div className="col-12 col-md-6">
                    <Form.Label className={'mb-0 align-self-start m-1 text-center'}>
                        <span className="text-nowrap">Pangakonto number</span>
                    </Form.Label>                    
                    <Form.Control
                        value={form.bankAccountNumber}
                        type="text"
                        onChange={(e) => setForm({...form, bankAccountNumber: e.target.value})}
                        placeholder="EE909900123456789012"
                        pattern={BANK_ACCOUNT_NUMBER_REGEX_PATTERN}
                        required={form.eInvoice}
                    />
                    <Form.Control.Feedback className={'text-right'} type="invalid">Pangakonto number ei ole valiidne</Form.Control.Feedback>
                </div>
              </Form>
            )}
            <div className="row mt-3">
              <div className="col-12 col-md-6">
                    <Form.Check
                        id='check-invoice-recipient-email'
                        custom
                        type="checkbox"
                        className='checkbox-large'
                        label='Soovin arvet teisele e-postile'
                        onChange={() => setForm({...form, electricityInvoiceRecipientEmailEnabled: !form.electricityInvoiceRecipientEmailEnabled})}
                        checked={form.electricityInvoiceRecipientEmailEnabled}
                    />
                </div>
            </div>
            {form.electricityInvoiceRecipientEmailEnabled && (
              <div className="row mt-1">
                <div className="col-12 col-md-6">
                    <Form.Label className={'mb-0 align-self-start m-1 text-center'}>
                      <span className="text-nowrap">Arve saaja e-post</span>
                    </Form.Label>                    
                    <Form.Control
                        value={form.electricityInvoiceRecipientEmail}
                        onChange={(e) => setForm({...form, electricityInvoiceRecipientEmail: e.target.value})}
                        required
                        type="text"
                        isInvalid={form.validated && (!form.electricityInvoiceRecipientEmail || !isValidCommaSeperatedEmail(form.electricityInvoiceRecipientEmail))}
                    />
                    <Form.Control.Feedback type="invalid">Vigane e-post!</Form.Control.Feedback>
                </div>
              </div>
            )}
        </div>
  )
}